import angular from 'angular';

import tszContact from './tsz-contact';

const tszContactModule = angular.module('tsz.components.tszContact', [])
  .component('tszContact', tszContact);

export default tszContactModule;



// WEBPACK FOOTER //
// ./src/components/tsz-contact/tsz-contact.module.js